<template>
  <section class="column-panel">
    <article class="screen-card chart-card">
      <TabHeader
        :items="declarationTabs"
        :activeIndex="declarationTabIndex"
        title-mode="switch"
        @change="handleDeclarationTabChange"
      ></TabHeader>
      <div ref="declarationChart" class="chart-box"></div>
    </article>

    <article class="screen-card chart-card">
      <TabHeader :items="['监管运输工具数量情况']" :activeIndex="0">
        <div class="tab-switch-group">
          <span
            v-for="(item, index) in transportTabs"
            :key="item"
            class="tab-btn transport-tab-btn"
            :class="{ active: transportTabIndex === index }"
            @click="handleTransportTabChange(index)"
          >{{ item }}</span>
        </div>
      </TabHeader>
      <div ref="transportChart" class="chart-box"></div>
    </article>

    <article class="screen-card chart-card">
      <TabHeader
        :items="tradeTabs"
        :activeIndex="tradeTabIndex"
        title-mode="switch"
        @change="handleTradeTabChange"
      ></TabHeader>
      <div v-if="tradeTabIndex === 0" class="trade-subtabs">
        <button
          v-for="(item, index) in crossBorderTabs"
          :key="item"
          type="button"
          class="trade-subtab"
          :class="{ active: crossBorderTabIndex === index }"
          @click="handleCrossBorderTabChange(index)"
        >
          {{ item }}
        </button>
      </div>
      <div
        ref="tradeChart"
        class="chart-box"
        :class="{ 'chart-box--with-subtabs': tradeTabIndex === 0 }"
      ></div>
    </article>
  </section>
</template>

<script>
import * as echarts from 'echarts'
import TabHeader from '@/components/common/TabHeader.vue'
import {
  getLeftBarterChart,
  getLeftBusinessNoChart,
  getLeftBusinessYesChart,
  getLeftFormChart,
  getLeftFreightChart,
  getLeftGoodsChart,
  getLeftMarketChart,
  getLeftRailwayChart,
  getLeftTaxationChart,
  getLeftTransportationChart
} from '@/api/datav'

const DATE_LABELS = []
const PALETTE = {
  blue: {
    solid: '#2CCBFF',
    dark: '#1584DA',
    light: '#72DEFE'
  },
  orange: {
    solid: '#FF9A1A',
    dark: '#DA4D15',
    light: '#FED572'
  },
  green: {
    solid: '#6CDF27',
    dark: '#6CDF27',
    light: '#8FF478'
  },
  yellow: '#FFE24A',
  line: '#FF7B1C'
}

export default {
  name: 'LeftPanel',
  props: {
    periodKey: {
      type: String,
      default: 'day'
    },
    dateRange: {
      type: Object,
      default: () => ({})
    }
  },
  components: { TabHeader },
  data() {
    return {
      declarationTabs: ['报关单数量', '货值', '货运量', '税收'],
      transportTabs: ['公路', '铁路'],
      tradeTabs: ['跨境电商监管', '市场采购'],
      crossBorderTabs: ['保税', '非保税'],
      declarationTabIndex: 0,
      transportTabIndex: 0,
      tradeTabIndex: 0,
      crossBorderTabIndex: 0,
      charts: {
        declaration: null,
        transport: null,
        trade: null
      },
      remoteDeclarationData: {},
      remoteTransportData: null,
      remoteRailwayData: null,
      remoteTradeData: {},
      transportData: {
        labels: [],
        legend: ['进口', '出口'],
        yAxisName: '辆',
        series: [
          { name: '进口', data: [] },
          { name: '出口', data: [] }
        ]
      },
      railwayData: {
        labels: [],
        legend: ['全部列数', '全部标箱', '天山号列数', '天山号标箱'],
        yAxisName: '列/个',
        series: [
          { name: '全部列数', data: [] },
          { name: '全部标箱', data: [] },
          { name: '天山号列数', data: [] },
          { name: '天山号标箱', data: [] }
        ]
      },
      declarationData: [
        {
          labels: [],
          legend: ['进口', '出口'],
          yAxisName: '票',
          series: [
            { name: '进口', data: [] },
            { name: '出口', data: [] }
          ]
        },
        {
          labels: [],
          legend: ['进口', '出口'],
          yAxisName: '亿',
          series: [
            { name: '进口', data: [] },
            { name: '出口', data: [] }
          ]
        },
        {
          labels: [],
          legend: ['进口', '出口'],
          yAxisName: '吨',
          series: [
            { name: '进口', data: [] },
            { name: '出口', data: [] }
          ]
        },
        {
          labels: [],
          legend: ['进口', '出口'],
          yAxisName: '万元',
          series: [
            { name: '进口', data: [] },
            { name: '出口', data: [] }
          ]
        }
      ],
      tradeData: {
        market: {
          legend: ['票数'],
          yAxisName: '票',
          series: [{ name: '票数', type: 'bar', data: [] }]
        },
        barter: {
          legend: ['易货贸易额进口', '易货贸易额出口', '票数', '易货贸易额'],
          yAxisName: '亿/票',
          series: [
            { name: '易货贸易额进口', type: 'bar', data: [] },
            { name: '易货贸易额出口', type: 'bar', data: [] },
            { name: '票数', type: 'line', data: [] },
            { name: '易货贸易额', type: 'bar', data: [] }
          ]
        },
        crossBorder: [
          {
            legend: ['1210贸易额', '同比'],
            yAxisName: '万/%',
            series: [
              { name: '1210贸易额', type: 'bar', data: [] },
              { name: '同比', type: 'line', data: [] }
            ]
          },
          {
            legend: ['9610贸易额', '9710贸易额', '9810贸易额'],
            yAxisName: '万',
            series: [
              { name: '9610贸易额', type: 'bar', data: [] },
              { name: '9710贸易额', type: 'bar', data: [] },
              { name: '9810贸易额', type: 'bar', data: [] }
            ]
          }
        ]
      }
    }
  },
  computed: {
    resolvedDeclarationData() {
      const remoteData = this.remoteDeclarationData[this.declarationTabIndex]
      if (remoteData && Array.isArray(remoteData.series)) {
        return remoteData
      }
      return this.declarationData[this.declarationTabIndex]
    },
    resolvedTransportData() {
      if (this.transportTabIndex === 1) {
        return this.remoteRailwayData && Array.isArray(this.remoteRailwayData.series)
          ? this.remoteRailwayData
          : this.railwayData
      }
      return this.remoteTransportData && Array.isArray(this.remoteTransportData.series)
        ? this.remoteTransportData
        : this.transportData
    },
    resolvedTradeData() {
      const remoteData = this.remoteTradeData
      if (
        Array.isArray(remoteData.crossBorder) &&
        remoteData.crossBorder.length &&
        remoteData.market &&
        remoteData.barter
      ) {
        return remoteData
      }
      return this.tradeData
    }
  },
  watch: {
    periodKey() {
      this.fetchPanelData()
      this.updateDeclarationChart()
      this.updateTransportChart()
      this.updateTradeChart()
    },
    dateRange: {
      deep: true,
      handler() {
        this.fetchPanelData()
      }
    }
  },
  async mounted() {
    this.initCharts()
    await this.fetchPanelData()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
    Object.values(this.charts).forEach(chart => {
      if (chart) {
        chart.dispose()
      }
    })
  },
  methods: {
    initCharts() {
      this.charts.declaration = echarts.init(this.$refs.declarationChart)
      this.charts.transport = echarts.init(this.$refs.transportChart)
      this.charts.trade = echarts.init(this.$refs.tradeChart)

      this.updateDeclarationChart()
      this.updateTransportChart()
      this.updateTradeChart()
    },
    async fetchPanelData() {
      const period = this.periodKey || 'day'
      const dateRange = this.dateRange || {}
      try {
        const [
          formChart,
          goodsChart,
          freightChart,
          taxationChart,
          transportChart,
          railwayChart,
          businessYesChart,
          businessNoChart,
          marketChart,
          barterChart
        ] = await Promise.all([
          getLeftFormChart(period, dateRange),
          getLeftGoodsChart(period, dateRange),
          getLeftFreightChart(period, dateRange),
          getLeftTaxationChart(period, dateRange),
          getLeftTransportationChart(period, dateRange),
          getLeftRailwayChart(period, dateRange),
          getLeftBusinessYesChart(period, dateRange),
          getLeftBusinessNoChart(period, dateRange),
          getLeftMarketChart(period, dateRange),
          getLeftBarterChart(period, dateRange)
        ])

        this.remoteDeclarationData = {
          0: formChart,
          1: goodsChart,
          2: freightChart,
          3: taxationChart
        }
        this.remoteTransportData = transportChart
        this.remoteRailwayData = railwayChart
        this.remoteTradeData = {
          crossBorder: [businessYesChart, businessNoChart],
          market: marketChart,
          barter: barterChart
        }
        this.$nextTick(() => {
          this.updateDeclarationChart()
          this.updateTransportChart()
          this.updateTradeChart()
        })
      } catch (error) {
        console.error('左侧图表数据加载失败', error)
      }
    },
    handleDeclarationTabChange(index) {
      this.declarationTabIndex = index
      this.updateDeclarationChart()
    },
    handleTransportTabChange(index) {
      this.transportTabIndex = index
      this.updateTransportChart()
    },
    handleTradeTabChange(index) {
      this.tradeTabIndex = index
      this.updateTradeChart()
      this.$nextTick(() => {
        this.handleResize()
      })
    },
    handleCrossBorderTabChange(index) {
      this.crossBorderTabIndex = index
      this.updateTradeChart()
    },
    updateDeclarationChart() {
      const chart = this.charts.declaration
      const currentData = this.resolvedDeclarationData
      if (!chart || !currentData) {
        return
      }

      chart.setOption(
        {
          tooltip: {
            ...this.getTooltipConfig(),
            formatter: params => this.formatInOutTooltip(params)
          },
          legend: this.getLegendConfig(currentData.legend, 6, 6, 13),
          grid: this.getGridConfig(40),
          xAxis: this.getCategoryAxis(currentData.labels || DATE_LABELS),
          yAxis: this.getValueAxis(currentData.yAxisName),
          series: currentData.series.map((item, index) =>
            this.createGradientBarSeries(item.name, item.data, index === 0 ? 'blue' : 'orange', 10)
          )
        },
        { notMerge: true }
      )
    },
    updateTransportChart() {
      const chart = this.charts.transport
      const currentData = this.resolvedTransportData
      if (!chart) {
        return
      }

      const isRoadMode = this.transportTabIndex === 0
      const firstSeries = isRoadMode
        ? this.getTransportSeriesItem(currentData.series, ['进口', '公路进口'], '进口', 0)
        : this.getTransportSeriesItem(currentData.series, '全部列数', '全部列数', 0)
      const secondSeries = isRoadMode
        ? this.getTransportSeriesItem(currentData.series, ['出口', '公路出口'], '出口', 1)
        : this.getTransportSeriesItem(currentData.series, '全部标箱', '全部标箱', 1)
      const legendData = isRoadMode ? ['进口', '出口'] : ['全部列数', '全部标箱']

      if (!isRoadMode) {
        chart.setOption(
          {
            tooltip: this.getTooltipConfig(),
            legend: {
              ...this.getLegendConfig(legendData, 6, 'center', 13, {
                right: 62,
                left: 88,
                width: '58%',
                itemGap: 20
              }),
              data: [
                { name: '全部列数', icon: 'rect' },
                { name: '全部标箱', icon: 'rect' }
              ]
            },
            grid: { left: 42, right: 62, top: 48, bottom: 20 },
            xAxis: this.getCategoryAxis(currentData.labels || DATE_LABELS),
            yAxis: [
              {
                ...this.getValueAxis('列数（列）', {
                  nameFontSize: 14,
                  namePadding: [0, 0, 8, 0]
                }),
                axisLine: { show: true, lineStyle: { color: 'rgba(114, 222, 254, 0.44)' } },
                axisLabel: { color: '#9ed5ff', fontSize: 13 }
              },
              {
                ...this.getValueAxis('标箱（个）', {
                  nameGap: 16,
                  nameFontSize: 13,
                  namePadding: [0, 0, 8, 14]
                }),
                splitLine: { show: false },
                axisLine: { show: true, lineStyle: { color: 'rgba(255, 154, 26, 0.62)' } },
                axisLabel: { color: '#ffd19a', fontSize: 13 }
              }
            ],
            series: [
              {
                ...this.createGradientBarSeries(firstSeries.name, firstSeries.data, 'blue', 10),
                yAxisIndex: 0,
                barCategoryGap: '46%'
              },
              this.createTransportLineSeries(secondSeries.name, secondSeries.data, PALETTE.orange.solid, 1)
            ]
          },
          { notMerge: true }
        )
        return
      }

      chart.setOption(
        {
          tooltip: {
            ...this.getTooltipConfig(),
            formatter: params => this.formatTransportTooltip(params)
          },
          legend: this.getLegendConfig(legendData, 6, 6, 13),
          grid: this.getGridConfig(40),
          xAxis: this.getCategoryAxis(currentData.labels || DATE_LABELS),
          yAxis: this.getValueAxis(isRoadMode ? '辆' : '列/个'),
          series: [
            {
              ...this.createGradientBarSeries(firstSeries.name, firstSeries.data, 'blue', 10),
              barCategoryGap: '42%'
            },
            {
              ...this.createGradientBarSeries(secondSeries.name, secondSeries.data, isRoadMode ? 'orange' : 'green', 10),
              barCategoryGap: '42%'
            }
          ]
        },
        { notMerge: true }
      )
    },
    createTransportLineSeries(name, data, color, yAxisIndex) {
      return {
        name,
        type: 'line',
        yAxisIndex,
        smooth: true,
        symbol: 'circle',
        symbolSize: 6,
        lineStyle: {
          width: 2.6,
          color
        },
        itemStyle: {
          color,
          borderColor: color,
          borderWidth: 2.5
        },
        areaStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            { offset: 0, color: `${color}2e` },
            { offset: 1, color: `${color}04` }
          ])
        },
        emphasis: {
          focus: 'series'
        },
        data: data || []
      }
    },
    getTransportSeriesItem(series, names, displayName, fallbackIndex) {
      const aliases = Array.isArray(names) ? names : [names]
      if (!Array.isArray(series) || !series.length) {
        return { name: displayName || aliases[0], data: [] }
      }
      const item = series.find(candidate => candidate && aliases.includes(candidate.name)) || series[fallbackIndex]
      return item ? { ...item, name: displayName || item.name } : { name: displayName || aliases[0], data: [] }
    },
    updateTradeChart() {
      const chart = this.charts.trade
      if (!chart) {
        return
      }

      const tradeData = this.resolvedTradeData

      if (this.tradeTabIndex === 0) {
        const currentData = tradeData.crossBorder[this.crossBorderTabIndex]
        chart.setOption(this.buildCrossBorderOption(currentData), { notMerge: true })
        return
      }

      chart.setOption(this.buildGradientTradeOption(tradeData.market), { notMerge: true })
    },
    buildGradientTradeOption(config) {
      const labels = config.labels || DATE_LABELS
      const crowdedHeader = (config.legend || []).length > 3 || config.yAxisName === '亿/票'
      return {
        tooltip: this.getTooltipConfig(),
        legend: this.getLegendConfig(config.legend, crowdedHeader ? 12 : 8, 'center', crowdedHeader ? 12 : 13, crowdedHeader ? {
          left: 54,
          right: 8,
          width: '82%',
          itemGap: 10
        } : {}),
        grid: this.getGridConfig(crowdedHeader ? 68 : 44),
        xAxis: this.getCategoryAxis(labels),
        yAxis: this.getValueAxis(config.yAxisName, crowdedHeader ? {
          nameGap: 18,
          nameFontSize: 13,
          namePadding: [0, 0, 14, 0]
        } : {}),
        series: this.buildTradeSeriesOptions(config.series, 14)
      }
    },
    buildCrossBorderOption(config) {
      const pointerStyle = {
        type: 'line',
        lineStyle: {
          color: 'rgba(210, 233, 255, 0.55)',
          type: 'dashed'
        }
      }

      return {
        tooltip: {
          ...this.getTooltipConfig(this.formatTradeTooltip),
          axisPointer: pointerStyle
        },
        legend: {
          data: config.legend,
          top: 10,
          left: 'center',
          width: '96%',
          itemWidth: 9,
          itemHeight: 9,
          itemGap: 10,
          textStyle: {
            color: '#cdeaff',
            fontSize: 11,
            padding: [0, 0, 0, 3]
          }
        },
        grid: {
          left: 34,
          right: 10,
          top: 82,
          bottom: 18
        },
        xAxis: {
          ...this.getCategoryAxis(config.labels || DATE_LABELS),
          axisLabel: {
            color: '#bde8ff',
            fontSize: 12,
            margin: 12
          },
          axisPointer: {
            show: true,
            ...pointerStyle
          }
        },
        yAxis: {
          ...this.getValueAxis(config.yAxisName),
          nameGap: 10,
          nameTextStyle: {
            color: '#bde8ff',
            fontSize: 13,
            padding: [0, 0, 4, -2]
          },
          axisLabel: {
            color: '#9ed5ff',
            fontSize: 12
          }
        },
        series: this.buildTradeSeriesOptions(config.series, 14, true)
      }
    },
    buildTradeSeriesOptions(series, barWidth, useSolidBar = false) {
      const barPalettes = useSolidBar
        ? [PALETTE.blue.solid, PALETTE.yellow, PALETTE.orange.solid, PALETTE.green.solid]
        : ['blue', 'orange', 'green', 'blue']
      let barIndex = 0

      return (series || []).map(item => {
        if (item.type === 'line') {
          return this.createLineSeries(item.name, item.data)
        }

        if (useSolidBar) {
          const color = barPalettes[barIndex % barPalettes.length]
          barIndex += 1
          return this.createSolidBarSeries(item.name, item.data, color, barWidth)
        }

        const paletteKey = barPalettes[barIndex % barPalettes.length]
        barIndex += 1
        return this.createGradientBarSeries(item.name, item.data, paletteKey, barWidth)
      })
    },
    createGradientBarSeries(name, data, paletteKey, barWidth, stack) {
      const palette = PALETTE[paletteKey]
      return {
        name,
        type: 'bar',
        stack,
        barWidth,
        itemStyle: {
          borderRadius: [2, 2, 0, 0],
          color: this.getGradientColor(palette.dark, palette.light)
        },
        emphasis: {
          focus: 'series'
        },
        data
      }
    },
    createSolidBarSeries(name, data, color, barWidth = 10) {
      return {
        name,
        type: 'bar',
        barWidth,
        itemStyle: {
          borderRadius: [2, 2, 0, 0],
          color
        },
        data
      }
    },
    createLineSeries(name, data) {
      return {
        name,
        type: 'line',
        smooth: true,
        symbol: 'circle',
        symbolSize: 8,
        yAxisIndex: 0,
        lineStyle: {
          width: 3,
          color: PALETTE.line
        },
        itemStyle: {
          color: '#ffffff',
          borderWidth: 3,
          borderColor: PALETTE.line
        },
        areaStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            { offset: 0, color: 'rgba(254, 213, 114, 0.35)' },
            { offset: 1, color: 'rgba(218, 77, 21, 0.02)' }
          ])
        },
        data
      }
    },
    getGradientColor(darkColor, lightColor) {
      return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
        { offset: 0, color: lightColor },
        { offset: 1, color: darkColor }
      ])
    },
    getTooltipConfig(formatter) {
      return {
        trigger: 'axis',
        backgroundColor: 'rgba(3, 17, 45, 0.9)',
        borderColor: 'rgba(68, 180, 255, 0.25)',
        borderWidth: 1,
        padding: [10, 14],
        textStyle: {
          color: '#dff6ff',
          fontSize: 14
        },
        axisPointer: {
          type: 'shadow',
          shadowStyle: {
            color: 'rgba(80, 138, 255, 0.08)'
          }
        },
        formatter
      }
    },
    getLegendConfig(data, top, position, fontSize, extraConfig = {}) {
      const config = {
        data,
        top,
        icon: 'rect',
        itemWidth: 12,
        itemHeight: 12,
        itemGap: 14,
        textStyle: {
          color: '#c5e9ff',
          fontSize
        }
      }

      if (position === 'center') {
        config.left = 'center'
      } else {
        config.right = position
      }

      return {
        ...config,
        ...extraConfig
      }
    },
    getGridConfig(top) {
      return { left: 36, right: 12, top, bottom: 20 }
    },
    getCategoryAxis(labels = DATE_LABELS) {
      return {
        type: 'category',
        data: labels,
        axisLine: {
          lineStyle: {
            color: 'rgba(138, 211, 255, 0.25)'
          }
        },
        axisLabel: {
          color: '#bde8ff',
          fontSize: 13
        },
        axisTick: {
          show: false
        }
      }
    },
    getValueAxis(name, options = {}) {
      return {
        type: 'value',
        name,
        minInterval: 1,
        nameGap: options.nameGap || 12,
        nameTextStyle: {
          color: '#bde8ff',
          fontSize: options.nameFontSize || 15,
          padding: options.namePadding || [0, 0, 8, 0]
        },
        splitLine: {
          lineStyle: {
            color: 'rgba(138, 211, 255, 0.12)'
          }
        },
        axisLabel: {
          color: '#9ed5ff',
          fontSize: 13
        }
      }
    },
    formatTradeTooltip(params) {
      return params
        .map(item => {
          const marker = `<span style="display:inline-block;width:10px;height:10px;margin-right:8px;border-radius:2px;background:${item.color};"></span>`
          return `${marker}${item.seriesName}<span style="float:right;margin-left:20px;">${item.value}</span>`
        })
        .join('<br/>')
    },
    formatInOutTooltip(params) {
      const rows = Array.isArray(params) ? params : []
      const values = rows.reduce((result, item) => {
        const value = Number(item && item.value)
        const name = item && item.seriesName
        if (name) {
          result[name] = Number.isFinite(value) ? value : 0
        }
        return result
      }, {})
      const total = Number.isFinite(values.总数)
        ? values.总数
        : (values.进口 || 0) + (values.出口 || 0)
      const marker = (color, label, value) => `<div style="display:flex;align-items:center;justify-content:space-between;gap:18px;margin-top:6px;"><span style="display:inline-flex;align-items:center;"><span style="display:inline-block;width:10px;height:10px;margin-right:8px;border-radius:50%;background:${color};"></span>${label}</span><strong style="color:#ffffff;font-weight:700;">${this.formatTooltipValue(value)}</strong></div>`
      const title = rows[0] && rows[0].axisValueLabel ? rows[0].axisValueLabel : ''
      return `<div><div style="margin-bottom:2px;font-weight:700;color:#dff4ff;">${title}</div>${marker('#b5d9ff', '总数', total)}${marker('#5bdcff', '进口', values.进口 || 0)}${marker('#ffca63', '出口', values.出口 || 0)}</div>`
    },
    formatTransportTooltip(params) {
      const rows = Array.isArray(params) ? params : []
      const values = rows.reduce((result, item) => {
        const value = Number(item && item.value)
        result[item && item.seriesName] = Number.isFinite(value) ? value : 0
        return result
      }, {})
      const total = Number.isFinite(values.总数)
        ? values.总数
        : (values.进口 || 0) + (values.出口 || 0)
      const marker = (color, label, value) => `<div style="display:flex;align-items:center;justify-content:space-between;gap:18px;margin-top:6px;"><span style="display:inline-flex;align-items:center;"><span style="display:inline-block;width:10px;height:10px;margin-right:8px;border-radius:50%;background:${color};"></span>${label}</span><strong style="color:#ffffff;font-weight:700;">${value}</strong></div>`
      const title = rows[0] && rows[0].axisValueLabel ? rows[0].axisValueLabel : ''
      return `<div><div style="margin-bottom:2px;font-weight:700;color:#dff4ff;">${title}</div>${marker('#b5d9ff', '总数', total)}${marker('#5bdcff', '进口', values.进口 || 0)}${marker('#ffca63', '出口', values.出口 || 0)}</div>`
    },
    formatTooltipValue(value) {
      const number = Number(value)
      if (!Number.isFinite(number)) {
        return value === undefined || value === null || value === '' ? '0' : String(value)
      }
      return Number.isInteger(number) ? String(number) : String(Number(number.toFixed(2)))
    },
    handleResize() {
      Object.values(this.charts).forEach(chart => {
        if (chart) {
          chart.resize()
        }
      })
    }
  }
}
</script>

<style scoped>
.column-panel {
  display: flex;
  flex-direction: column;
  gap: 0.8vh;
  min-height: 0;
}

.column-panel > .screen-card {
  flex: 1 1 0;
  min-height: 0;
}

.screen-card {
  position: relative;
  padding: 0.4vh 0.4vw 0.2vh;
  overflow: hidden;
}

.chart-card {
  min-height: 0;
}

.chart-card :deep(.tab-header) {
  align-items: center;
  height: 3.44vh;
  padding-left: 3.14vw;
  padding-right: 0.24vw;
  margin-bottom: 0.28vh;
}

.transport-tab-btn {
  min-width: 2.68vw;
}

.chart-period-select-wrap {
  position: relative;
  display: inline-flex;
  align-items: center;
  min-width: clamp(76px, 4.6vw, 120px);
  height: 2.18vh;
  border: 0.05vw solid rgba(56, 177, 255, 0.32);
  border-radius: 0.46vw;
  background:
    linear-gradient(180deg, rgba(14, 86, 170, 0.5), rgba(6, 34, 90, 0.5)),
    rgba(4, 21, 62, 0.62);
  box-shadow:
    inset 0 0 0.88vw rgba(24, 162, 255, 0.12),
    0 0 0.68vw rgba(18, 132, 218, 0.12);
  overflow: hidden;
}

.chart-period-select-wrap::after {
  content: '';
  position: absolute;
  top: 50%;
  right: 0.56vw;
  width: 0.42vw;
  height: 0.24vw;
  background: rgba(238, 249, 255, 0.92);
  clip-path: polygon(0 0, 100% 0, 50% 100%);
  transform: translateY(-50%);
  pointer-events: none;
}

.chart-period-select {
  width: 100%;
  height: 100%;
  padding: 0 1.42vw 0 0.68vw;
  border: 0;
  color: rgba(214, 242, 255, 0.92);
  font-size: 0.58vw;
  font-weight: 600;
  line-height: 1;
  background: transparent;
  outline: none;
  appearance: none;
  cursor: pointer;
}

.chart-period-select option {
  color: #eaf8ff;
  background: #0a2f73;
}

.chart-box {
  position: relative;
  z-index: 1;
  width: 100%;
  height: calc(100% - 4.6vh);
  min-height: 0;
}

.chart-box--with-subtabs {
  height: calc(100% - 7.3vh);
}

.trade-subtabs {
  position: relative;
  z-index: 2;
  display: flex;
  justify-content: center;
  gap: 1.34vw;
  margin: 0.34vh 0 0.56vh;
}

.trade-subtab {
  position: relative;
  padding: 0;
  color: rgba(220, 239, 255, 0.75);
  font-size: clamp(13px, 0.86vw, 16px);
  font-weight: 600;
  line-height: 1.2;
  background: transparent;
  border: 0;
  cursor: pointer;
}

.trade-subtab::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: -0.32vh;
  height: 0.22vh;
  background: transparent;
  border-radius: 999px;
  transition: background-color 0.2s ease;
}

.trade-subtab.active {
  color: #62dfff;
}

.trade-subtab.active::after {
  background: #27d8ff;
}
</style>
